import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const LinkIcon: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45 45"
      fill="none"
      transform={`rotate(${rotation ?? 0})`}
    >
      <path
        d="M16.5628 31.2852H12.8822C10.4417 31.2852 8.10126 30.3157 6.37562 28.5901C4.64997 26.8644 3.68051 24.5239 3.68051 22.0835C3.68051 19.6431 4.64997 17.3026 6.37562 15.5769C8.10126 13.8513 10.4417 12.8818 12.8822 12.8818H16.5628"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.68066"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M27.603 12.8818H31.2837C33.7241 12.8818 36.0646 13.8513 37.7902 15.5769C39.5159 17.3026 40.4854 19.6431 40.4854 22.0835C40.4854 24.5239 39.5159 26.8644 37.7902 28.5901C36.0646 30.3157 33.7241 31.2852 31.2837 31.2852H27.603"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.68066"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.7225 22.084H29.4452"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.68066"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </IconWrapper>
);

LinkIcon.displayName = 'LinkIcon';
